<template>
	<v-app id="inspire">
		<v-main>
			<v-container fluid fill-height style="min-height: 100vh">
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md4>
						<v-card outlined elevation="0">
							<v-toolbar color="light-blue darken-4" dark>
								<v-toolbar-title>Login</v-toolbar-title>
								<v-spacer></v-spacer>
							</v-toolbar>
							<two-factor-step
								v-if="challenge"
								:challenge-token="challenge.challengeToken"
								:method="challenge.method"
								@success="onTwoFactorSuccess"
								@error="notifyError"
								@info="notifyInfo"
								@cancel="challenge = null"
							/>
							<v-card-text v-if="!challenge">
								<v-form>
									<v-text-field hide-details="auto" v-model="form.email" :error-messages="messages.email" prepend-icon="person" label="Email" type="text"></v-text-field>
									<v-text-field hide-details="auto"
										v-model="form.password"
										:error-messages="messages.password"
										prepend-icon="lock"
										label="Password"
										type="password"
										:append-icon="value ? 'visibility' : 'visibility_off'"
										@click:append="() => (value = !value)"
										:type="value ? 'password' : 'text'"
									></v-text-field>
								</v-form>
							</v-card-text>
							<v-card-actions v-if="!challenge">
								<v-btn text small color="primary" to="/forgot-password">Password dimenticata?</v-btn>
								<v-spacer></v-spacer>
								<v-btn color="primary" @click.prevent="login">Login</v-btn>
							</v-card-actions>
						</v-card>
						<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
							{{ snackbar.text }}
							<v-btn dark text @click="snackbar.snackbar = false">
								{{ $vuetify.lang.t('$vuetify.close') }}
							</v-btn>
						</v-snackbar>
					</v-flex>
				</v-layout>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import store from '@/store';
import TwoFactorStep from './components/TwoFactorStep.vue';
export default {
	name: 'Login',
	components: { TwoFactorStep },
	data() {
		return {
			dialog: false,
			// sfida del secondo fattore ({ challengeToken, method }) quando l'utente ha la 2FA attiva
			challenge: null,
			value: String,
			form: {
				password: '',
				email: '',
			},
			messages: {
				name: [],
				password: [],
			},
			snackbar: {
				snackbar: false,
				color: '',
				mode: '',
				timeout: 6000,
				text: '',
			},
		};
	},
	created() {
		// ritorno dalla pagina del link di recupero
		if (this.$route.query.reset) {
			this.notifyInfo('Password aggiornata. Accedi con la nuova password');
		}
		axios
			.get(`${store.getters['settings/getUrl']}auth/login`)
			.then(response => {
				console.log(reponse);
				//context.commit('setCsrf', response.data.csrfToken);
				return true;
			})
			.catch(err => {
				return { status: false };
			});
	},
	computed: {
		...mapGetters({
			getAutenticate: 'profile/getAutenticate',
			getUrl: 'settings/getUrl',
		}),
	},
	methods: {
		...mapMutations({
			setName: 'profile/setName',
			setEmail: 'profile/setEmail',
			setAutenticate: 'profile/setAutenticate',
			setToken: 'profile/setToken',
			setRefresh: 'profile/setRefresh',
			setId: 'profile/setId',
			setPreload: 'settings/setPreload',
			setCsrf: 'profile/setCsrf',
		}),
		...mapActions({
			loginAuth: 'profile/asyncFetchData',
		}),

		async login() {
			this.setPreload(true);

			var payload = this.form;
			this.messages = {
				name: [],
				password: [],
			};

			try {
				const dataresponse = await this.loginAuth(payload);
				if (dataresponse.status === 422) {
					let errors = dataresponse.data.error;
					if (errors) {
						errors.forEach(value => {
							this.messages[value.param] = this.$vuetify.lang.t(`$vuetify.errors.${value.msg}`);
						});
					}
				}

				if (dataresponse.data.message) {
					this.snackbar.color = 'error';
					this.snackbar.text = this.$vuetify.lang.t(`$vuetify.errors.${dataresponse.data.message}`); //err.response.data.message;
					this.snackbar.snackbar = true;
					this.snackbar.mode = 'multi-line';
					this.snackbar.timeout = 5000;
				}

				if (dataresponse.status === 201 && dataresponse.data.twoFactorRequired) {
					this.challenge = { challengeToken: dataresponse.data.challengeToken, method: dataresponse.data.method };
				} else if (dataresponse.status === 201) {
					this.$router.push('/home');
				}

				this.setPreload(false);
			} catch (e) {
				console.log(e.message);
				console.log(e.stack);
			}
		},
		onTwoFactorSuccess({ backupCodeUsed }) {
			if (backupCodeUsed) {
				// avviso prima del redirect: il login smonta la pagina e con lei lo snackbar
				this.notifyInfo('Hai usato un codice di backup: ne restano meno, puoi rigenerarli dal Profilo');
				setTimeout(() => this.$router.push('/home'), 2500);
				return;
			}
			this.$router.push('/home');
		},
		notifyError(code) {
			this.snackbar.color = 'error';
			this.snackbar.text = this.$vuetify.lang.t(`$vuetify.errors.${code}`);
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
		notifyInfo(text) {
			this.snackbar.color = 'info';
			this.snackbar.text = text;
			this.snackbar.snackbar = true;
			this.snackbar.mode = 'multi-line';
			this.snackbar.timeout = 5000;
		},
	},
};
</script>

<style scoped>
.v-application--wrap {
	min-height: 100vh;
}
</style>
